import { Grid, GridList, List, useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'
import { KPIItemType, LandingSujectKpisModel } from '../clients.model'
import KPIListItem from './KPIListItem'

export interface KPIListProps {
  KPIItems: LandingSujectKpisModel
}

const KPIList: React.FC<KPIListProps> = ({ KPIItems }) => {
  const currentTheme = useTheme()
  const horizontalDisposition = useMediaQuery(currentTheme.breakpoints.between('sm', 'md'))

  return (
    <Grid container item xs={12} justify={'center'}>
      <List
        style={{
          display: 'flex',
          flexDirection: horizontalDisposition ? 'row' : 'column'
        }}
      >
        <KPIListItem
          key={`${KPIItems.activeContracts}-${KPIItemType.ACTIVE_CONTRACTS}`}
          KPI={KPIItems.activeContracts}
          itemType={KPIItemType.ACTIVE_CONTRACTS}
          renderArrow={false}
          align="right"
        />
        <KPIListItem
          key={`${KPIItems.balance30}-${KPIItemType.BALANCE_30}`}
          KPI={KPIItems.balance30}
          itemType={KPIItemType.BALANCE_30}
          renderArrow
          align={horizontalDisposition ? 'center' : 'right'}
        />
        <KPIListItem
          key={`${KPIItems.balanceYtd}-${KPIItemType.BALANCE_YTD}`}
          KPI={KPIItems.balanceYtd}
          itemType={KPIItemType.BALANCE_YTD}
          renderArrow
          align={horizontalDisposition ? 'left' : 'right'}
        />
      </List>
    </Grid>
  )
}

export default KPIList
